const LoadingSkeleton = ({animate=true, width, height, margin, borderRadius, customStyles}:{borderRadius?: number, animate?: boolean; width: number, height: number | string, margin?: string | number, customStyles?: object}) => {
    return (
        <div style={{width: width+"%", height, margin, borderRadius, ...customStyles}} className="loading-skeleton">
            {animate && <span></span>}
        </div>
    )
}

export default LoadingSkeleton;